// import {IconButton} from '@mui/material'
import {styled} from '@mui/material/styles'

const SideMenuDrawerHeader = styled('div')(({theme}) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
}))

export default SideMenuDrawerHeader
